import { supabase } from './supabaseClient';

// Counterpart to the Hub's `openWithSso()`: if we were opened with session
// tokens in the URL fragment (cross-domain SSO handoff), apply them to this
// app's own Supabase client, then immediately scrub the fragment from the
// address bar so the tokens never linger in browser history.
export async function consumeSsoHandoff(): Promise<void> {
  const hash = window.location.hash.startsWith('#') ? window.location.hash.slice(1) : window.location.hash;
  if (!hash) return;

  const params = new URLSearchParams(hash);
  const access_token = params.get('access_token');
  const refresh_token = params.get('refresh_token');
  if (!access_token || !refresh_token) return;

  await supabase.auth.setSession({ access_token, refresh_token });
  history.replaceState(null, '', window.location.pathname + window.location.search);
}
